import { render } from "./Ortho3DEditor.vue?vue&type=template&id=19b23c0e&scoped=true"
import script from "./Ortho3DEditor.vue?vue&type=script&lang=js"
export * from "./Ortho3DEditor.vue?vue&type=script&lang=js"

import "./Ortho3DEditor.vue?vue&type=style&index=0&id=19b23c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19b23c0e"]])

export default __exports__